module.exports = __webpack_public_path__ + "img/GS_Profile-Sifiso Mlambo.223e576b.png";